import { render, staticRenderFns } from "./DxNurseryClassificationReport.vue?vue&type=template&id=1bfe3aad&"
import script from "./DxNurseryClassificationReport.vue?vue&type=script&lang=js&"
export * from "./DxNurseryClassificationReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports